import React, { Component } from "react";
import { str2bool } from "../../../helpers/stringControllers";
// currency json
import { currencyTypes } from "../../../models/product-data-model";
import ajaxMethods from "../../../api/ajax-methods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { getFromLocalStorage } from "../../../helpers/localStorage";
import { appInsights } from "../../../config/appInsights";

export default class Settings extends Component {
  state = {
    allCurrencyTypes: [],
    investmentEdit: false,
    repaymentEdit: false,
    generateKey: false,
    publicKey: "",
    investmentFormCopy: {
      treshold_amount: 0,
      minimum_amount: 0,
      maximum_amount: 0,
      callback_url: "",
      // execute_transfer: false,
      loan_calculation_method: 1,
      // interest_rate: 0,
      min_interest_rate: 0,
    },
    repaymentFormCopy: {
      repayment_cycle: "",
    },
  };

  inputChangeHandler = (e) => {
    const { name, value, type, dataset } = e.currentTarget;
    let selectedForm = dataset["form"];

    // if (type === "number" ) {
    //     this.setState({
    //         [`${selectedForm}Form`]:{
    //             ...this.state[`${selectedForm}Form`],
    //             [name]: value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //         }
    //     });
    // }
    if (type === "radio" && name === "execute_transfer") {
      this.setState({
        [`${selectedForm}FormCopy`]: {
          ...this.state[`${selectedForm}FormCopy`],
          [name]: str2bool(value),
        },
      });
    } else if (type === "radio" && name === "loan_calculation_method") {
      this.setState({
        [`${selectedForm}FormCopy`]: {
          ...this.state[`${selectedForm}FormCopy`],
          [name]: parseInt(value),
        },
      });
    } else {
      this.setState(
        {
          [`${selectedForm}FormCopy`]: {
            ...this.state[`${selectedForm}FormCopy`],
            [name]: value,
          },
        },
        () => {}
      );
    }
  };

  cancelUpdateHandler = (e) => {
    e.preventDefault();
    let selectedForm = e.currentTarget.dataset["form"];
    this.setState({
      [`${selectedForm}FormCopy`]: this.state[`${selectedForm}Form`],
      [`${selectedForm}Edit`]: false,
    });
  };

  editModeHandler = (e) => {
    e.preventDefault();
    let selectedForm = e.currentTarget.dataset["form"];

    this.setState({
      [`${selectedForm}Edit`]: true,
    });
  };

  onSettingsUpdate = (e) => {
    e.preventDefault();

    let selectedForm = e.currentTarget.dataset["form"];
    const { ...data } = this.state[`${selectedForm}FormCopy`];
    const {
      currentAggregator: { aggregatorId, aggregatorName },
    } = this.state;

    let responseParams = {
      xaggregator_id: aggregatorId,
      ...data,
    };

    if (selectedForm === "loan") {
      // ajaxMethods.post(ajaxEndpoints.AGGR_LOAN_SETTINGS, responseParams)
      //     .then(response => {
      //         if(response.status === 201){
      //             return this.props.onToast('success', `You have succefully updated ${ aggregatorName }'s loan settings`);
      //         }else if(response.status === 400){
      //             return this.props.onToast('error', 'There was an issue updating loan settings');
      //         }else{
      //             return this.props.onToast('warning', 'There was an issue updating loan settings');
      //         }
      //     })
      //     .catch(error => {
      //         return this.props.onToast('error', 'There was an issue updating loan settings');
      //     });

      this.props.saveAggrLoanSettings(responseParams);
      this.setState({
        [`${selectedForm}Edit`]: false,
      });
    }
    if (selectedForm === "investment") {
      ajaxMethods
        .post(ajaxEndpoints.AGGR_INVESTMENT_SETTINGS_UPDATE, responseParams)
        .then((response) => {
          if (response.status === 200) {
            return this.props.onToast(
              "success",
              `You have succefully updated ${aggregatorName}'s investment settings`
            );
          } else if (response.status === 400) {
            return this.props.onToast(
              "error",
              `There was an issue updating investment settings: ${response.data.message}`
            );
          } else {
            return this.props.onToast(
              "warning",
              "There was an issue updating investment settings"
            );
          }
        })
        .catch((error) => {
          appInsights.trackException({
            exception: error,
            properties: {
              fileName: "Settings.js",
            },
          });
          return this.props.onToast(
            "error",
            "There was an issue updating investment settings"
          );
        });

      this.setState({
        [`${selectedForm}Edit`]: false,
      });
    }
  };

  repaymentUpdateHandler = (e) => {
    const { repayment_cycle } = this.state.repaymentFormCopy;
    const {
      currentAggregator: { aggregatorId, aggregatorName },
    } = this.state;

    let selectedForm = e.currentTarget.dataset["form"];

    if (repayment_cycle.trim() === "") {
      return this.props.onToast(
        "warning",
        "You have not selected a repayment cycle"
      );
    } else {
      const responseParams = {
        aggregator_id: aggregatorId,
        repayment_cycle: repayment_cycle,
      };

      ajaxMethods
        .post(ajaxEndpoints.REPAYMENT_CYCLE_UPDATE, responseParams)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            return this.props.onToast(
              "success",
              `You have successfully updated ${aggregatorName}'s repayment cycle`
            );
          } else if (response.status === 400) {
            return this.props.onToast(
              "error",
              "There was an issue updating repayment cycle"
            );
          } else {
            return this.props.onToast(
              "warning",
              "There was an issue updating repayment cycle"
            );
          }
        })
        .catch((error) => {
          appInsights.trackException({
            exception: error,
            properties: {
              fileName: "Settings.js",
            },
          });
          return this.props.onToast(
            "error",
            "There was an issue updating repayment cycle"
          );
        });

      this.setState({
        [`${selectedForm}Edit`]: false,
      });
    }
  };

  generateAggregatorKey = () => {
    const aggr_id = getFromLocalStorage("agg_id");

    ajaxMethods
      .get(ajaxEndpoints.GENERATE_AGGREGATOR_KEY + "?aggregator_id=" + aggr_id)
      .then((response) => {
        if (response) {
          this.getGeneratedAggregatorKey();
          this.setState({});
        } else {
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "Settings.js",
          },
        });
      });
  };

  // refreshed public and private key genration
  onRefresh = () => {
    const aggr_id = getFromLocalStorage("agg_id");

    ajaxMethods
      .get(ajaxEndpoints.REFRESH_KEY + "?aggregator_id=" + aggr_id)
      .then((response) => {
        if (response) {
          this.getGeneratedAggregatorKey();
          this.setState({});
        } else {
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "Settings.js",
          },
        });
      });
  };
  //get generated public and private keys

  getGeneratedAggregatorKey = () => {
    const aggr_id = getFromLocalStorage("agg_id");
    ajaxMethods
      .get(ajaxEndpoints.GET_GENERATED_KEYS + "?aggregator_id=" + aggr_id)
      .then((response) => {
        if (response.data) {
          this.setState({
            privateKey: response.data.private_key,
            publicKey: response.data.public_key,
          });
        } else {
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "Settings.js",
          },
        });
      });
  };

  componentDidMount() {
    this.getAllCurrency();
    // this.props.onGetGeneratedAggregatorKey()
  }

  // // get all imported currency
  getAllCurrency = () => {
    const allCurrencyTypes = currencyTypes.map((ecosystem, index) => {
      const { code, name } = ecosystem;
      return (
        <option key={index} id={code} value={code}>
          {name}
        </option>
      );
    });
    this.setState({
      allCurrencyTypes: allCurrencyTypes,
    });
  };

  render() {
    const {
      investmentEdit,
      repaymentEdit,
      investmentFormCopy,
      repaymentFormCopy,
      publicKey,
    } = this.state;
    // const { min_interest_rate, loanProcess } = loanForm;

    const {
      treshold_amount,
      minimum_amount,
      maximum_amount,
      callback_url,
      //   execute_transfer,
      loan_calculation_method,
      //   interest_rate,
      min_interest_rate,
      currency_code,
    } = investmentFormCopy;
    const { repayment_cycle } = repaymentFormCopy;

    const { allCurrencyTypes } = this.state;

    return (
      <div className="row mt-20">
        {/* <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="card">
                        <div className="body text-center">
                            <h3 className="m-t-0"><i className="adv-icon fas fa-cogs"/>&nbsp; Loan</h3>
                            <p className="settings-block text-muted">Advancly global loan settings </p>
                            <div className="grid__full settings-block">
                                <label className="label-txt">Loan Process</label>
                                
                                <div className="form-group grid__full">
                                    <div className="glass input-group">
                                        <div className="login-session">
                                            <label htmlFor="loginSession"
                                                className="adv-check form-component">
                                                <input 
                                                    id="loginSession"
                                                    type="radio"
                                                    name="loanProcess"
                                                    value="automatic"
                                                    checked={loanProcess === "automatic" ? true : ""}
                                                    data-form="loan" 
                                                    disabled={(!loanEdit)}
                                                    onChange={this.props.onChange}
                                                    className="has-value"/>
                                                <i className="primary"/>
                                                Automatic Mode
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group grid__full">
                                    <div className="glass input-group">
                                        <div className="login-session">
                                            <label htmlFor="loginSession"
                                                className="adv-check form-component">
                                                <input  
                                                    id="loginSession"
                                                    type="radio" 
                                                    name="loanProcess"
                                                    value="manual"
                                                    checked={loanProcess === "manual" ? true : ""}
                                                    data-form="loan" 
                                                    disabled={(!loanEdit)}
                                                    onChange={this.props.onChange}
                                                    className="has-value"/>
                                                <i className="primary"/>
                                                Manual Mode
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <label className="label-txt">Interest Rate</label>
                                <div className="form-group inputWithIcon">
                                    <input type="text"
                                        className="user__form form-control"
                                        placeholder="Advancly Interest rate"
                                        autoComplete="off"
                                        data-form="loan" 
                                        readOnly={(!loanEdit)}
                                        name="interestRate"
                                        value={interestRate}
                                        onChange={this.props.onChange}
                                        required=""/>
                                    <i className="fas fa-percent" aria-hidden="true"/>
                                </div>
                            </div>

                            <div className="grid__full">
                                {(loanEdit)
                                ?   <div className="Form__action-buttons">
                                        <button type="button" 
                                                className="btn zoom-element login-btn m-r-1"
                                                data-form="loan" 
                                                onClick={this.cancelUpdateHandler}>
                                            <i className="fas fa-times-circle"/>&nbsp; Cancel
                                        </button>
                                        <button type="button" 
                                                className="btn zoom-element login-btn m-l-1"
                                                data-form="loan" 
                                                onClick={this.props.onSettingsUpdate}
                                                >
                                            <i className="fas fa-save"/>&nbsp; Save
                                        </button>
                                    </div>
                                :   <button type="submit" 
                                            className="zoom-element btn login-btn"
                                            data-form="loan" 
                                            onClick={this.editModeHandler} >
                                        <i className="fas fa-edit"/>&nbsp; Edit
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div> */}

        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="card">
            <div className="body text-center">
              <h3 className="m-t-0">
                <i className="adv-icon fas fa-cogs" />
                &nbsp; Investment
              </h3>
              <p className="settings-block text-muted">
                Aggregator investment settings
              </p>

              <label className="label-txt">Threshold Amount</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  placeholder="Threshold Amount"
                  autoComplete="off"
                  name="treshold_amount"
                  value={treshold_amount}
                  data-form="investment"
                  readOnly={!investmentEdit}
                  onChange={this.props.onChange}
                />
                <i className="fas fa-lock" />
              </div>

              <div className="grid__full settings-block">
                <label className="label-txt">Investment Amount</label>
                <div className="form-group inputWithIcon">
                  <input
                    type="number"
                    className="user__form form-control"
                    placeholder="Minimum Investment Amount"
                    autoComplete="off"
                    name="minimum_amount"
                    value={minimum_amount}
                    data-form="investment"
                    readOnly={!investmentEdit}
                    onChange={this.props.onChange}
                    required=""
                  />
                  <i className="fas fa-greater-than" aria-hidden="true" />
                </div>

                <div className="form-group inputWithIcon">
                  <input
                    type="number"
                    className="user__form form-control"
                    placeholder="Maximum Investment Amount"
                    autoComplete="off"
                    data-form="investment"
                    readOnly={!investmentEdit}
                    name="maximum_amount"
                    value={maximum_amount}
                    onChange={this.props.onChange}
                    required=""
                  />
                  <i className="fas fa-less-than" aria-hidden="true" />
                </div>
              </div>

              <label className="label-txt">Callback Url</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  data-form="investment"
                  placeholder="Callback url"
                  readOnly={!investmentEdit}
                  name="callback_url"
                  value={callback_url}
                  onChange={this.props.onChange}
                />
                <i className="fas fa-link" />
              </div>
              <label className="label-txt">Currency</label>
              <div className="form-group inputWithIcon">
                <select
                  type="text"
                  className="user__form form-control"
                  data-form="investment"
                  placeholder="selected_currency"
                  disabled={!investmentEdit}
                  name="currency_code"
                  value={currency_code}
                  onChange={this.props.onChange}
                >
                  <option selected> Choose currency</option>
                  {allCurrencyTypes}
                </select>
              </div>

              <div className="grid__full settings-block">
                {/* <label className="label-txt">Execute Transfer</label>
                <div className="form-group grid__full">
                  <div className="glass input-group">
                    <div className="login-session">
                      <label
                        htmlFor="loginSession"
                        className="adv-check form-component"
                      >
                        <input
                          id="execute_yes"
                          type="radio"
                          name="execute_transfer"
                          value={true}
                          checked={execute_transfer === true ? true : ""}
                          data-form="investment"
                          disabled={!investmentEdit}
                          onChange={this.props.onChange}
                          className="has-value"
                        />
                        <i className="primary" />
                        Yes
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group grid__full">
                  <div className="glass input-group">
                    <div className="login-session">
                      <label
                        htmlFor="loginSession"
                        className="adv-check form-component"
                      >
                        <input
                          id="execute_no"
                          type="radio"
                          name="execute_transfer"
                          value={false}
                          checked={execute_transfer === false ? true : ""}
                          data-form="investment"
                          disabled={!investmentEdit}
                          onChange={this.props.onChange}
                          className="has-value"
                        />
                        <i className="primary" />
                        No
                      </label>
                    </div>
                  </div>
                </div>

                <label className="label-txt">Interest Rate</label>
                <div className="form-group inputWithIcon">
                  <input
                    type="text"
                    className="user__form form-control"
                    placeholder="Advancly Interest rate"
                    autoComplete="off"
                    data-form="investment"
                    readOnly={!investmentEdit}
                    name="interest_rate"
                    value={interest_rate}
                    onChange={this.props.onChange}
                    required=""
                  />
                  <i className="fas fa-percent" aria-hidden="true" />
                </div> */}

                <label className="label-txt">Minimum Interest Rate</label>
                <div className="form-group inputWithIcon">
                  <input
                    type="text"
                    className="user__form form-control"
                    placeholder="Advancly Interest rate"
                    autoComplete="off"
                    data-form="investment"
                    readOnly={!investmentEdit}
                    name="min_interest_rate"
                    value={min_interest_rate}
                    onChange={this.props.onChange}
                    required=""
                  />
                  <i className="fas fa-percent" aria-hidden="true" />
                </div>
              </div>

              <label className="label-txt">Loan Calculation Method</label>
              <div className="form-group grid__full">
                <div className="glass input-group">
                  <div className="login-session">
                    <label
                      htmlFor="loginSession"
                      className="adv-check form-component"
                    >
                      <input
                        id="reducing_balance"
                        type="radio"
                        name="loan_calculation_method"
                        value={1}
                        checked={loan_calculation_method === 1 ? true : ""}
                        data-form="investment"
                        disabled={!investmentEdit}
                        onChange={this.props.onChange}
                        className="has-value"
                      />
                      <i className="primary" />
                      Reducing Balance
                    </label>
                  </div>
                </div>
              </div>
              <div className="form-group grid__full">
                <div className="glass input-group">
                  <div className="login-session">
                    <label
                      htmlFor="loginSession"
                      className="adv-check form-component"
                    >
                      <input
                        id="fixed_balance"
                        type="radio"
                        name="loan_calculation_method"
                        value={2}
                        checked={loan_calculation_method === 2 ? true : ""}
                        data-form="investment"
                        disabled={!investmentEdit}
                        onChange={this.props.onChange}
                        className="has-value"
                      />
                      <i className="primary" />
                      Fixed Balance
                    </label>
                  </div>
                </div>
              </div>

              <div className="grid__full">
                {investmentEdit ? (
                  <div className="Form__action-buttons">
                    <button
                      type="button"
                      className="btn zoom-element login-btn m-r-1"
                      data-form="investment"
                      onClick={this.cancelUpdateHandler}
                    >
                      <i className="fas fa-times-circle" />
                      &nbsp; Cancel
                    </button>
                    <button
                      type="button"
                      className="btn zoom-element login-btn m-l-1"
                      data-form="investment"
                      onClick={this.onSettingsUpdate}
                    >
                      <i className="fas fa-save" />
                      &nbsp; Save
                    </button>
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="zoom-element btn login-btn"
                    data-form="investment"
                    onClick={this.editModeHandler}
                  >
                    <i className="fas fa-edit" />
                    &nbsp; Edit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="card">
            <div className="body text-center">
              <h3 className="m-t-0">
                <i className="adv-icon fas fa-cogs" />
                &nbsp; Repayment
              </h3>
              <p className="settings-block text-muted">
                I want to update how Advancly functions{" "}
              </p>
              <div className="grid__full settings-block">
                <label className="label-txt">Repayment Cycle</label>
                <div className="form-group grid__full">
                  <div className="glass input-group">
                    <div className="login-session">
                      <label
                        htmlFor="loginSession"
                        className="adv-check form-component"
                      >
                        <input
                          id="repaymentOneOff"
                          type="radio"
                          name="repayment_cycle"
                          value="oneoff"
                          checked={repayment_cycle === "oneoff" ? true : ""}
                          data-form="repayment"
                          disabled={!repaymentEdit}
                          onChange={this.props.onChange}
                          className="has-value"
                        />
                        <i className="primary" />
                        One Off
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group grid__full">
                  <div className="glass input-group">
                    <div className="login-session">
                      <label
                        htmlFor="loginSession"
                        className="adv-check form-component"
                      >
                        <input
                          id="repaymentWeekly"
                          type="radio"
                          name="repayment_cycle"
                          data-form="repayment"
                          disabled={!repaymentEdit}
                          value="weekly"
                          checked={repayment_cycle === "weekly" ? true : ""}
                          onChange={this.props.onChange}
                          className="has-value"
                        />
                        <i className="primary" />
                        Weekly
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group grid__full">
                  <div className="glass input-group">
                    <div className="login-session">
                      <label
                        htmlFor="loginSession"
                        className="adv-check form-component"
                      >
                        <input
                          id="repaymentMonthly"
                          type="radio"
                          name="repayment_cycle"
                          data-form="repayment"
                          disabled={!repaymentEdit}
                          value="monthly"
                          checked={repayment_cycle === "monthly" ? true : ""}
                          onChange={this.props.onChange}
                          className=""
                        />
                        <i className="primary" />
                        Monthly
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid__full">
                {repaymentEdit ? (
                  <div className="Form__action-buttons">
                    <button
                      type="button"
                      className="btn zoom-element login-btn m-r-1"
                      data-form="repayment"
                      onClick={this.cancelUpdateHandler}
                    >
                      <i className="fas fa-times-circle" />
                      &nbsp; Cancel
                    </button>
                    <button
                      type="button"
                      className="btn zoom-element login-btn m-l-1"
                      data-form="repayment"
                      onClick={this.repaymentUpdateHandler}
                    >
                      <i className="fas fa-save" />
                      &nbsp; Save
                    </button>
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="zoom-element btn login-btn"
                    data-form="repayment"
                    onClick={this.editModeHandler}
                  >
                    <i className="fas fa-edit" />
                    &nbsp; Edit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12">
          <div className="card">
            <div className="body text-center">
              <h3 className="m-t-0">
                <i className="adv-icon fas fa-cogs" />
                &nbsp; Public Key
              </h3>
              {publicKey == null ? (
                <p className="settings-block text-muted m-t-2">
                  No public key. Generate Key
                </p>
              ) : (
                <p className="settings-block text-muted m-t-2">{publicKey}</p>
              )}

              <div className="grid__full">
                {publicKey == null ? (
                  <div className="Form__action-buttons">
                    <button
                      type="button"
                      className="btn zoom-element login-btn"
                      data-form="repayment"
                      onClick={this.generateAggregatorKey}
                    >
                      <i className="fas fa-unlock" />
                      &nbsp; Generate Key
                    </button>
                  </div>
                ) : (
                  <div className="Form__action-buttons">
                    <button
                      type="button"
                      className="btn zoom-element login-btn"
                      data-form="repayment"
                      // onClick={ e =>window.confirm("Are you sure you want to refresh public key?") && this.onRefresh}
                      onClick={this.onRefresh}
                    >
                      <i className="fas fa-key" />
                      &nbsp; Refresh Key
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
